<template>
  <v-row>
    <v-progress-linear v-if="loading" indeterminate color="blue darken-2"></v-progress-linear>
    <v-col lg="12" class="page-title">
      <v-card class="mx-auto mb-1" outlined>
        <v-card-title>
          {{title}}
          <span v-if="data">- {{data.name}} - {{data.code}}</span>
          <v-spacer></v-spacer>
          <v-text-field
            hide-details
            :value="search"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="grey-lighten-3 ma-2"
            background-color="#FAFAFA"
            outlined
            fieldset="#ddd"            
            @input="changeData($event)"
            dense
          ></v-text-field>
        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PageTitleWithSearch",
  props: ["title", "loading", "data", "search"],
  data() {
    return {};
  },
  methods: {
    changeData(event) {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.$emit("searchText", event);
      }, 500);
    }
  }
};
</script>
<style>
.page-title .v-card__title {
  padding: 0;
  padding-left: 15px;
  padding-right: 15px;
}

.page-title fieldset {
  color: #ddd !important;
}
</style>